/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Panel,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import dashboardActions from 'loraactions/dashboard';
import callAPI from '@/api/callAPI';
import DetailHeader from '../DetailHeader';
import TimeSelect from '../TimeSelect';
import DvcssModal from '../DvcssModal';
import EditName from '../EditName';
import RefreshBtn from '../RefreshBtn';
import DeviceMap from '../DeviceMap';
import DpsModal from '../DpsModal';
import styles from './styles.scss';

const kLoops = 100;
const kInterval = 6;

const propTypes = {
  intl: PropTypes.object.isRequired,
  dashId: PropTypes.string.isRequired,
  dashboardData: PropTypes.object.isRequired,
  appState: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  getDashboard: PropTypes.func.isRequired,
  getDps: PropTypes.func.isRequired,
  getDeveui: PropTypes.func.isRequired,
  getRefreshCount: PropTypes.func.isRequired,
};

class SingleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: props.dashboardData,
      appState: props.appState,
      checkedId: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleOperation = this.handleOperation.bind(this);
    this.handleOnConfirmDps = this.handleOnConfirmDps.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.refresh = 0;
  }

  componentWillMount() {
    const { dashId, getDashboard } = this.props;
    getDashboard(dashId);
  }

  componentDidMount() {
    this.calMapHeight();
  }

  componentWillReceiveProps(nextProps) {
    const { dashboardData, appState } = nextProps;
    if (dashboardData !== this.props.dashboardData) {
      const { status, data } = dashboardData;
      if (status === 'success' && data) {
        this.handleData(dashboardData);
      }
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  componentWillUnmount() {
    this.refresh = 0;
  }

  calMapHeight() {
    let timer = 0;
    let mapHeight;
    if (timer < 5 && !mapHeight) {
      if (this.container) {
        mapHeight = window.innerHeight - this.container.offsetHeight - 100;
        this.setState({ mapHeight });
      } else {
        timer += 1;
        setTimeout(() => {
          this.calMapHeight();
        }, 1000);
      }
    }
  }

  handleData(dashboardData) {
    const { ext } = dashboardData.data;
    const checkedIds = JSON.parse(ext).deveui;
    this.setState({
      checkedIds,
      dps: _.map(JSON.parse(ext).charts, item => item.type),
      dashboardData,
    }, () => {
      this.props.getDps(this.state.dps);
    });
  }

  handleOperation(d = [], deveui) {
    const { dashId, getDeveui } = this.props;
    let { dashboardData: { data: { ext } } } = this.state;
    ext = JSON.parse(ext);
    ext = { ...ext, deveui };
    callAPI({
      endpoint: `/lora/dashboards/${dashId}`,
      method: 'PUT',
      body: { ext: JSON.stringify(ext) },
    }).then(() => {})
      .catch(() => {});
    getDeveui(deveui);
    this.setState({ checkedIds: deveui });
  }

  handleOnConfirmDps(dps) {
    const { checkedIds } = this.state;
    let { dashboardData: { data: { ext } } } = this.state;
    ext = JSON.parse(ext);
    let dpsNew = _.split(dps, ',');
    dpsNew = _.filter(dpsNew, dp => (dp !== ''));
    let charts = _.map(dpsNew, item => ({ type: item }));
    charts = _.concat(ext.charts, charts);
    ext = { ...ext, deveui: checkedIds, charts };
    callAPI({
      endpoint: `/lora/dashboards/${this.props.dashId}`,
      method: 'PUT',
      body: { ext: JSON.stringify(ext) },
    })
      .then(() => {})
      .catch(() => {});
    this.setState({ showDpsModal: false, reset: new Date() });
    dpsNew = _.concat(this.state.dps, dpsNew);
    dpsNew = _.uniq(dpsNew);
    this.props.getDps(dpsNew);
  }

  handleRefresh() {
    if (this.refresh === (kLoops + 1)) {
      this.refresh = 0;
      this.setState({ selectDisabled: false });
    } else {
      this.props.getRefreshCount(this.refresh);
      this.setState({ isRefreshing: true });
      this.refresh += 1;
      _.delay(() => {
        this.setState({ isRefreshing: false });
      }, 1000);
      this.setState({ selectDisabled: true });
    }
  }

  handleOneClick() {
    this.refresh = 0;
    this.setState({ selectDisabled: false });
  }

  handleOnHideDps() {
    this.setState({ showDpsModal: false });
  }

  render() {
    const { appId, dashId } = this.props;
    const {
      dashboardData: { data },
      showDpsModal = false,
      showDeviceModal = false,
      isRefreshing = false,
      checkedIds = [],
      mapHeight,
    } = this.state;
    // let { dps } = this.state;
    if (!data) {
      return null;
    }
    // dps = dps || _.map(JSON.parse(data.ext).charts, item => item.type);
    const header = (
      <div className={`clearfix ${styles.leftTool}`}>
        <span className="pull-left">
          <EditName name={data.name} dashId={dashId} />
        </span>
        <div className="pull-right">
          <Button
            bsStyle="aisz-success-b"
            className={styles.marginRm}
            onClick={() => this.setState({ showDpsModal: true })}
          >
            {this.intlMsg.msg('add.dpschart')}
          </Button>
          <Button
            bsStyle="aisz-primary-b"
            onClick={() => this.setState({ showDeviceModal: true })}
          >
            {this.intlMsg.msg('adddevice')}
          </Button>
        </div>
      </div>
    );

    return (
      <div ref={(input) => { this.container = input; }} >
        <DetailHeader dash={data} />
        <Grid fluid>
          <div>
            <Panel bsStyle="aisz-white" header={header} styleName="add-panel">
              <Row>
                <Col md={11}>
                  <span className="pull-left">
                    <TimeSelect />
                  </span>
                </Col>
                <Col md={1} className="text-right" styleName="refresh">
                  <RefreshBtn
                    loops={kLoops}
                    interval={kInterval}
                    reloading={isRefreshing}
                    onReload={this.handleRefresh}
                    onOneClick={() => this.handleOneClick()}
                  />
                </Col>
              </Row>
            </Panel>
            {
              mapHeight &&
              <div style={{ height: mapHeight }}>
                <DeviceMap appId={appId} type="detail" dashId={dashId} />
              </div>
            }
          </div>
          <DpsModal
            showModal={showDpsModal}
            // dps={dps}
            appId={appId}
            onConfirm={this.handleOnConfirmDps}
            onHide={() => this.handleOnHideDps()}
          />
          <DvcssModal
            appId={appId}
            showModal={showDeviceModal}
            onChoose={this.handleOperation}
            onHide={() => this.setState({ showDeviceModal: false })}
            checkedIds={checkedIds}
          />
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appState: state.app.getApp,
  dashId: ownProps.params.dashid,
  appId: ownProps.params.id,
  dashboardData: state.dashboard.getDashboard,
  time: state.dashboard.getTimes,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDashboard: dashboardActions.getDashboard,
  getDps: dashboardActions.getDps,
  getDeveui: dashboardActions.getDeveui,
  getRefreshCount: dashboardActions.getRefreshCount,
};

SingleDetail.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(SingleDetail,
  styles,
)));






// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/MultipleDetail/index.jsx